import React, { useEffect } from 'react'
import PureCounter from "@srexi/purecounterjs";
import { useGetRequestsDataQuery } from '../../../redux/apiSlices/requestSlice';
import SmallSpinner from '../../../components/SmallSpinner/SmallSpinner';

function Counter() {

	const {
    data,
    isLoading
  } = useGetRequestsDataQuery()

 

  useEffect(()=>{
    if(data) {

      const pure = new PureCounter();
    }
  },[data])

  return (
    <div class="row g-4 mb-4">
			{/* <!-- Counter item --> */}
			<div class="col-md-6 col-xxl-3">
				<div class="card card-body bg-danger bg-opacity-10 p-4 h-100">
					<div class="d-flex justify-content-between align-items-center">
						{/* <!-- Digit --> */}
						<div>
							{isLoading ? <div><SmallSpinner/></div> : 
							<h2 class="purecounter mb-0 fw-bold" data-purecounter-start="0" data-purecounter-end={data?.all_requests} data-purecounter-delay="200">0</h2>
							}
							<span class="mb-0 h6 fw-light">جميع الطلبات</span>
						</div>
						{/* <!-- Icon --> */}
						<div class="icon-lg rounded-circle bg-danger text-white mb-0"><i class="fas fa-file fa-fw"></i></div>
					</div>
				</div>
			</div>

			{/* <!-- Counter item --> */}
			<div class="col-md-6 col-xxl-3">
				<div class="card card-body bg-warning bg-opacity-15 p-4 h-100">
					<div class="d-flex justify-content-between align-items-center">
						{/* <!-- Digit --> */}
						<div>
						{isLoading ? <div><SmallSpinner/></div> : 
							<h2 class="purecounter mb-0 fw-bold" data-purecounter-start="0" data-purecounter-end={data?.new_requests} data-purecounter-delay="200">0</h2>
							}
							<span class="mb-0 h6 fw-light">الطلبات الجديدة</span>
              <i class="fa-solid "></i>
						</div>
						{/* <!-- Icon --> */}
						<div class="icon-lg rounded-circle bg-warning text-white mb-0"><i class="fas fa-file-circle-plus fa-fw"></i></div>
					</div>
				</div>
			</div>

			{/* <!-- Counter item --> */}
			<div class="col-md-6 col-xxl-3">
				<div class="card card-body bg-purple bg-opacity-10 p-4 h-100">
					<div class="d-flex justify-content-between align-items-center">
						{/* <!-- Digit --> */}
						<div>
						{isLoading ? <div><SmallSpinner/></div> : 
							<h2 class="purecounter mb-0 fw-bold" data-purecounter-start="0" data-purecounter-end={data?.secretary_accepted} data-purecounter-delay="200">0</h2>
							}
              <span class="mb-0 h6 fw-light">الطلبات المقبولة</span>
						</div>
						{/* <!-- Icon --> */}
						<div class="icon-lg rounded-circle bg-purple text-white mb-0"><i class="fas fa-file-lines fa-fw"></i></div>
					</div>
				</div>
			</div>

			{/* <!-- Counter item --> */}
			<div class="col-md-6 col-xxl-3">
				<div class="card card-body bg-secondary bg-opacity-10 p-4 h-100">
					<div class="d-flex justify-content-between align-items-center">
						{/* <!-- Digit --> */}
						<div>
						{isLoading ? <div><SmallSpinner/></div> : 
							<h2 class="purecounter mb-0 fw-bold" data-purecounter-start="0" data-purecounter-end={data?.nominated} data-purecounter-delay="200">0</h2>
							}
							<span class="mb-0 h6 fw-light">الطلبات المرشحة</span>
						</div>
						{/* <!-- Icon --> */}
						<div class="icon-lg rounded-circle bg-secondary text-white mb-0"><i class="fas fa-file-invoice fa-fw"></i></div>
					</div>
				</div>
			</div>
			
			{/* <!-- Counter item --> */}
			<div class="col-md-6 col-xxl-3">
				<div class="card card-body bg-success bg-opacity-10 p-4 h-100">
					<div class="d-flex justify-content-between align-items-center">
						{/* <!-- Digit --> */}
						<div>
						{isLoading ? <div><SmallSpinner/></div> : 
							<h2 class="purecounter mb-0 fw-bold" data-purecounter-start="0" data-purecounter-end={data?.manager_approved} data-purecounter-delay="200">0</h2>
							}
							<span class="mb-0 h6 fw-light">الطلبات المعتمدة</span>
						</div>
						{/* <!-- Icon --> */}
						<div class="icon-lg rounded-circle bg-success text-white mb-0"><i class="fas fa-file-circle-check fa-fw"></i></div>
					</div>
				</div>
			</div>

			{/* <!-- Counter item --> */}
			<div class="col-md-6 col-xxl-3">
				<div class="card card-body bg-primary bg-opacity-10 p-4 h-100">
					<div class="d-flex justify-content-between align-items-center">
						{/* <!-- Digit --> */}
						<div>
						{isLoading ? <div><SmallSpinner/></div> : 
							<h2 class="purecounter mb-0 fw-bold" data-purecounter-start="0" data-purecounter-end={data?.received} data-purecounter-delay="200">0</h2>
							}
              <span class="mb-0 h6 fw-light">طلبات مستلمة</span>
						</div>
						{/* <!-- Icon --> */}
						<div class="icon-lg rounded-circle bg-primary text-white mb-0"><i class="fas fa-gift fa-fw"></i></div>
					</div>
				</div>
			</div>

			
		</div>
  )
}

export default Counter


